export interface GadgetDefinition {
  id: 'grapple' | 'repulsor' | 'magnet';
  label: string;
  control: string;
  cooldown: number;
  color: number;
}

export const gadgetDefinitions: Record<GadgetDefinition['id'], GadgetDefinition> = {
  grapple: {
    id: 'grapple',
    label: 'GRAPPLE',
    control: 'Q',
    cooldown: 2.2,
    color: 0x67e1cf,
  },
  repulsor: {
    id: 'repulsor',
    label: 'REPULSOR',
    control: 'E',
    cooldown: 3.8,
    color: 0xff8a3d,
  },
  magnet: {
    id: 'magnet',
    label: 'MAGNET',
    control: 'R',
    cooldown: 5.2,
    color: 0xc78cff,
  },
};

export const grappleAnchors = [
  { x: 0, y: 10.0, z: 11.5 },
  { x: 1.35, y: 8.9, z: 24.0 },
  { x: -1.35, y: 6.4, z: 39.2 },
  { x: 0, y: 9.3, z: 55.0 },
  { x: 0.7, y: 9.7, z: 71.2 },
  { x: -1.35, y: 6.2, z: 86.8 },
  { x: 0, y: 9.5, z: 103.0 },
  { x: 1.35, y: 6.4, z: 118.3 },
  { x: -1.35, y: 9.5, z: 133.9 },
  { x: 1.35, y: 6.2, z: 149.7 },
  { x: -1.35, y: 8.9, z: 165.2 },
  { x: 0, y: 9.3, z: 180.9 },
] as const;
